import { HttpManager } from "../network/interface/HttpManager"
import { ServiceError } from "../../ui/error/ServiceError"
import { ServiceReview, ServiceReviewUpdate } from "../../domain/entities/ServiceReview"
import { CreateServiceReviewParams } from "../../domain/useCases/serviceReviews/createServiceReview"
import { Endpoint } from "../network/endpoint"

export class ServiceReviewsService {
	private _http: HttpManager

	constructor({ HttpManager }: { HttpManager: HttpManager }) {
		this._http = HttpManager
	}

	public async getServiceReviews(serviceId: number, pagination?: number, limit?: number): Promise<ServiceReview[]> {
		try {
			const params: { [param: string]: any } = {}
			if (pagination !== undefined) {
				params.page = pagination
			}
			if (limit !== undefined) {
				params.limit = limit
			}

			const response = await this._http.requestNewApi({
				url: Endpoint.SERVICE_REVIEWS.replace(":serviceId", serviceId.toString()),
				method: "GET",
				params
			})
			return response.data
		} catch (error: any) {
			throw new ServiceError({
				errorMessage: "Error fetching service reviews",
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}

	public async createServiceReview(params: CreateServiceReviewParams): Promise<ServiceReview> {
		try {
			const data = {
				serviceId: params.serviceId,
				userId: params.userId,
				review: params.review,
				rating: params.rating
			}

			const response = await this._http.requestNewApi({
				url: Endpoint.SERVICE_REVIEW_CREATE,
				method: "POST",
				data
			})

			return response.data
		} catch (error: any) {
			throw new ServiceError({
				errorMessage: "Error creating service review",
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}

	public async updateServiceReview(reviewUpdate: ServiceReviewUpdate): Promise<void> {
		try {
			await this._http.requestNewApi({
				url: Endpoint.SERVICE_REVIEW.replace(":id", reviewUpdate.id.toString()),
				method: "PUT",
				data: {
					review: reviewUpdate.review,
					rating: reviewUpdate.rating,
					userId: reviewUpdate.userId
				}
			})
		} catch (error: any) {
			throw new ServiceError({
				errorMessage: "Error updating service review",
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}

	public async deleteServiceReview(reviewId: number): Promise<void> {
		try {
			const deleteUrl = Endpoint.SERVICE_REVIEW.replace(":id", reviewId.toString())
			console.log("Deleting review with URL:", deleteUrl, "ID:", reviewId)

			await this._http.requestNewApi({
				url: deleteUrl,
				method: "DELETE"
			})

			console.log("Review deleted successfully")
		} catch (error: any) {
			console.error("Delete service review error:", error, "for ID:", reviewId)
			throw new ServiceError({
				errorMessage: "Error deleting service review",
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}
}
